/*
 * LUCRÜ™ — AI voice co-host for live streamers.
 * Copyright (c) 2026 LUCRÜ. All rights reserved.
 * LUCRÜ™ is a trademark of LUCRÜ. Proprietary software licensed under the
 * terms set out in the LICENSE file at the repository root.
 * Unauthorised copying, modification, or redistribution is prohibited.
 */
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Relay from "@/pages/Relay";
import Pricing from "@/pages/Pricing";
import Subscribe from "@/pages/Subscribe";
import VipClaim from "@/pages/VipClaim";
import Leaderboard from "@/pages/Leaderboard";
import AdminPage from "@/pages/Admin";
import OverlayOBS from "@/pages/OverlayOBS";
import DemoPage from "@/pages/DemoPage";
import { Terms, Privacy } from "@/pages/Legal";
import { BillingSuccess, BillingCancel } from "@/pages/Billing";
import InstallPWA from "@/components/InstallPWA";
import AutoUpdater from "@/components/AutoUpdater";
import { I18nProvider } from "@/lib/i18n";

function App() {
  return (
    <I18nProvider>
      <div className="App min-h-screen bg-[#05050A] text-white">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/relay/:sessionId" element={<Relay />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/subscribe/:lookupKey" element={<Subscribe />} />
            <Route path="/vip" element={<VipClaim />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/overlay/:sessionId" element={<OverlayOBS />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/billing/success" element={<BillingSuccess />} />
            <Route path="/billing/cancel" element={<BillingCancel />} />
          </Routes>
          <InstallPWA />
          <AutoUpdater />
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </div>
    </I18nProvider>
  );
}

export default App;
